import { render, staticRenderFns } from "./welcomeMessage.vue?vue&type=template&id=30f5c697"
import script from "./welcomeMessage.vue?vue&type=script&lang=js"
export * from "./welcomeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports